import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const StatCard = ({ value, label, icon }) => (
  <div className="text-center md:text-left border-l-2 border-zinc-800 pl-6">
    <div className="flex items-center justify-center md:justify-start mb-2 space-x-2">
      <SafeIcon icon={icon} className="text-yellow-400 h-4 w-4" />
      <span className="text-zinc-500 font-black uppercase text-[10px] tracking-widest">{label}</span>
    </div>
    <div className="text-4xl font-black tracking-tight">{value}</div>
  </div>
);

export default StatCard;